/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationStoreCheckBuyProductsCheckBuyProductsData } from './FxIdApplicationStoreCheckBuyProductsCheckBuyProductsData';
import {
    FxIdApplicationStoreCheckBuyProductsCheckBuyProductsDataFromJSON,
    FxIdApplicationStoreCheckBuyProductsCheckBuyProductsDataFromJSONTyped,
    FxIdApplicationStoreCheckBuyProductsCheckBuyProductsDataToJSON,
    FxIdApplicationStoreCheckBuyProductsCheckBuyProductsDataToJSONTyped,
} from './FxIdApplicationStoreCheckBuyProductsCheckBuyProductsData';

/**
 * 
 * @export
 * @interface FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponse
 */
export interface FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponse {
    /**
     * 
     * @type {Array<FxIdApplicationStoreCheckBuyProductsCheckBuyProductsData>}
     * @memberof FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponse
     */
    Products: Array<FxIdApplicationStoreCheckBuyProductsCheckBuyProductsData>;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponse
     */
    ClientMetadata?: string | null;
}

/**
 * Check if a given object implements the FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponse interface.
 */
export function instanceOfFxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponse(value: object): value is FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponse {
    if (!('Products' in value) || value['Products'] === undefined) return false;
    return true;
}

export function FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponseFromJSON(json: any): FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponse {
    return FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponseFromJSONTyped(json, false);
}

export function FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'Products': ((json['Products'] as Array<any>).map(FxIdApplicationStoreCheckBuyProductsCheckBuyProductsDataFromJSON)),
        'ClientMetadata': json['ClientMetadata'] == null ? undefined : json['ClientMetadata'],
    };
}

export function FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponseToJSON(json: any): FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponse {
    return FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponseToJSONTyped(json, false);
}

export function FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponseToJSONTyped(value?: FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Products': ((value['Products'] as Array<any>).map(FxIdApplicationStoreCheckBuyProductsCheckBuyProductsDataToJSON)),
        'ClientMetadata': value['ClientMetadata'],
    };
}

